<li class="m-option-separator"
    role="separator"></li>
